/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  uuid?: string;
}>;

export const DeleteMetadataGenre = async (option: Option) => {
  const $uuid = <Variable name="uuid" scalar={<UuidScalar isNullable={true} />} value={option.uuid} />;

  const { query, variables } = render(
    <Mutation operationName="DELETE_METADATA_GENRE">
      <SelectionSet
        name="deleteMetadata_genre_relation"
        alias="deleteMetadataGenre"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteMetadataGenre: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
